import { useState } from 'react'

import { useDispatch } from '@tabeeb/store'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@collaborate-health/uikit'
import { UserSignatureType } from '@tabeeb/enums'

import { createUserSignature } from '@tabeeb/modules/forms/actions'

import { SignatureInput } from './ManageSignatureDialog.styles'

export interface ManageSignatureDialogProps {
  isOpen: boolean
  onClose: () => void
}

const createSvgFromString = (text: string) => {
  return `<svg xmlns="http://www.w3.org/2000/svg" height="100" width="300"><text fill="black" font-family="Mr Dafoe"  font-style="italic" font-size="20" x="50%" y="55%" text-anchor="middle">${text}</text></svg>`
}

const ManageSignatureDialog: React.FC<ManageSignatureDialogProps> = ({ isOpen, onClose }) => {
  const dispatch = useDispatch()

  const [text, setText] = useState('')

  const handleSave = () => {
    dispatch(
      createUserSignature({
        Value: createSvgFromString(text),
        Type: UserSignatureType.Text,
      })
    )

    onClose()
  }

  return (
    <Dialog open={isOpen} maxWidth='xs' fullWidth onClose={onClose}>
      <DialogTitle>Create signature</DialogTitle>
      <DialogContent>
        <SignatureInput
          type='text'
          value={text}
          placeholder='Type your name'
          fullWidth
          inputProps={{
            maxLength: 30,
          }}
          onChange={(e) => {
            setText(e.target.value)
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button color='primary' onClick={onClose}>
          Cancel
        </Button>

        <Button variant='contained' color='primary' disabled={text.length < 1} onClick={handleSave}>
          Save and sign form
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ManageSignatureDialog

